import { formattedRevenueAmountValues, formattedSoldTicketValue } from '../../common/utility/utility';
import {
    FETCH_DAILY_REVENUE_DETAILS, SET_REVENUE_EMPTY, SET_SELECTEDREVENUE_DATA_REQUEST, SET_SELECTEDREVENUE_DATA,
    SUBMITTED_REVENUE_REQUEST, SUBMITTED_REVENUE, UPLOAD_FILE_REQUEST, UPLOAD_EXCEL_REQUEST, UPLOAD_EXCEL_SUCCESS,
    FETCH_REMARK_OPTIONS, CANCEL_CHANGE_REQUEST, SUBMIT_CHANGE_REQUEST, CHANGE_REQUEST_NOT_ALLOWED,
    SUBMIT_SELECTED_SUCCESS, TOGGLE_UPLOAD_FILE_MODEL, TOGGLE_UNBLOCK_REQUEST_MODEL,
    SET_SELECT_UNBLOCK_REQUEST_REVENUE, UNBLOCK_REQUEST_NOT_ALLOWED, SUBMIT_UNBLOCK_REQUEST, FETCH_WEEKLY_REVENUE_DETAILS, UPLOAD_WEEKLY_EXCEL_SUCCESS
} from './actionTypes';

export const revenueReducer = (state, action) => {
    switch (action.type) {
        case FETCH_DAILY_REVENUE_DETAILS:
            return {
                ...state,
                revenue: action.payload.revenue
            }
        case FETCH_WEEKLY_REVENUE_DETAILS:
            return {
                ...state,
                revenue: InitialFormatRevenueData(action.payload.revenue)
            }
        case SET_REVENUE_EMPTY:
            return {
                ...state,
                revenue: []
            }
        case SET_SELECTEDREVENUE_DATA_REQUEST:
            return {
                ...state,
                setSelectedRevenue: null,
                submittedRevenue: null,
                selectedContractCodeIndex: null,
                selectedContractCode: null
            }
        case SET_SELECTEDREVENUE_DATA:
            return {
                ...state,
                submittedRevenue: null,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                selectedContractCode: action.payload.selectedContract,
                revenue: state.revenue.map((data, index) => index === action.payload.selectedContractCodeIndex ?
                    { ...action.payload.selectedRevenue } : data)
            }
        case SUBMITTED_REVENUE_REQUEST:
            return {
                ...state,
                submittedRevenueId: null,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                submittedRevenue: action.payload.submittedRevenue,
            }
        case SUBMITTED_REVENUE:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                revenue: state.revenue.map((data, index) => index === action.payload.selectedContractCodeIndex ?
                    {
                        ...action.payload.submittedRevenue,
                        revenueId: action.payload.submittedRevenueId,
                        isSubmitted: action.payload.submittedRevenueId > 0,
                        isChangeRequestAllowed: action.payload.changeRequestData && action.payload.changeRequestData.isChangeRequestAllowed,
                        changeRequest: { ...action.payload.changeRequestData.changeRequest },
                        revenueAmount: action.payload.changeRequestData.changeRequest ?
                            { ...action.payload.changeRequestData.changeRequest.revenueAmount }
                            : { ...action.payload.submittedRevenue.revenueAmount },
                        soldTicket: action.payload.changeRequestData.changeRequest ?
                            action.payload.changeRequestData.changeRequest.soldTicket
                            : action.payload.submittedRevenue.soldTicket,
                        isShopOpen: action.payload.changeRequestData.changeRequest ?
                            action.payload.changeRequestData.changeRequest.isShopOpen
                            : action.payload.submittedRevenue.isShopOpen,
                        remarksId: action.payload.changeRequestData.changeRequest ?
                            action.payload.changeRequestData.changeRequest.remarksId
                            : action.payload.submittedRevenue.remarksId,
                        remarksCode: action.payload.changeRequestData.changeRequest ?
                            action.payload.changeRequestData.changeRequest.remarksCode
                            : action.payload.submittedRevenue.remarksCode
                    } : data)
            }
        case UPLOAD_FILE_REQUEST:
            return {
                ...state,
                showUploadFileModel: true,
                acceptFileType: action.payload.acceptFileType,
                modelHeaderTitle: action.payload.modelHeaderTitle,
                selectedRevenue: action.payload.selectedRevenue,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex
            }
        case UPLOAD_EXCEL_REQUEST:
            return {
                ...state,
                showUploadFileModel: false,
                acceptFileType: "",
                modelHeaderTitle: "",
                selectedContractCodeIndex: null
            }
        case UPLOAD_EXCEL_SUCCESS:
            return {
                ...state,
                revenue: action.payload.revenue.map(d => {
                    return {
                        ...d,
                        revenueAmount: formattedRevenueAmountValues(d),
                        soldTicket: formattedSoldTicketValue(d)
                    }
                })
            }
        case UPLOAD_WEEKLY_EXCEL_SUCCESS:
            return {
                ...state,
                revenue: action.payload.revenue.map((d,index) => {
                    return {
                        ...d,
                        "index":index,
                        "contId":d.contractId,
                        "contractId":d.contractId + "#" + d.revenueDate,
                        "revenueAmount": formattedRevenueAmountValues(d),
                        "soldTicket": formattedSoldTicketValue(d)                
                    }
                })
            }
        case FETCH_REMARK_OPTIONS:
            return {
                ...state,
                remarksOptions: action.payload.remarksOptions
            };
        case CANCEL_CHANGE_REQUEST:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                revenue: state.revenue.map((data, index) => index === action.payload.selectedContractCodeIndex ?
                    {
                        ...data,
                        revenueAmount: { ...action.payload.changeRequestData.changeRequest.revenueAmount },
                        soldTicket: action.payload.changeRequestData.changeRequest.soldTicket,
                        isShopOpen: action.payload.changeRequestData.changeRequest.isShopOpen,
                        remarksId: action.payload.changeRequestData.changeRequest.remarksId,
                        remarksCode: action.payload.changeRequestData.changeRequest.remarksCode,
                        changeRequest: {
                            ...action.payload.changeRequestData.changeRequest,
                            businessPartnerRemarks: ""
                        },
                        tax_0_ErrorMessage: "",
                        tax_6_ErrorMessage: "",
                        tax_12_ErrorMessage: "",
                        tax_21_ErrorMessage: "",
                        soldTicket_ErrorMessage: "",
                        isShopOpen_ErrorMessage: "",
                        remarks_ErrorMessage: "",
                        businessPartnerRemarks_ErrorMessage: ""
                    } : data)
            }
        case SUBMIT_CHANGE_REQUEST:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                revenue: state.revenue.map((data, index) => index === action.payload.selectedContractCodeIndex ?
                    {
                        ...data,
                        isChangeRequestAllowed: action.payload.changeRequestData && action.payload.changeRequestData.isChangeRequestAllowed,
                        changeRequest: {
                            ...data.changeRequest,
                            changeRequestNumber: action.payload.changeRequestData.changeRequestNumber,
                            changeRequestStatus: action.payload.changeRequestData.changeRequestStatus
                        }
                    } : data)
            }
        case CHANGE_REQUEST_NOT_ALLOWED:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                revenue: state.revenue.map((data, index) => index === action.payload.selectedContractCodeIndex ?
                    {
                        ...data,
                        isChangeRequestAllowed: false,
                        revenueAmount: { ...data.changeRequest.revenueAmount },
                        soldTicket: data.changeRequest.soldTicket,
                        isShopOpen: data.changeRequest.isShopOpen,
                        remarksId: data.changeRequest.remarksId,
                        remarksCode: data.changeRequest.remarksCode,
                        changeRequest: null
                    } : data)
            }
        case SUBMIT_SELECTED_SUCCESS:
            return {
                ...state,
                revenue: state.revenue.map((data) => {
                    return { ...setSubmitSelectedSuccessData(data, action.payload.changeRequestData, action.payload.revDate, action.payload.isWeekly) }
                }
                )
            }
        case TOGGLE_UPLOAD_FILE_MODEL:
            return {
                ...state,
                showUploadFileModel: action.payload.showUploadFileModel,
                acceptFileType: action.payload.acceptFileType,
                modelHeaderTitle: action.payload.modelHeaderTitle
            }
        case TOGGLE_UNBLOCK_REQUEST_MODEL:
            return {
                ...state,
                showUnblockRequestModel: action.payload.showUnblockRequestModel
            }
        case SET_SELECT_UNBLOCK_REQUEST_REVENUE:
            return {
                ...state,
                selectedRevenue: action.payload.selectedRevenue,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex
            }
        case SUBMIT_UNBLOCK_REQUEST:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                revenue: state.revenue.map((data, index) => data.contractCode === action.payload.selectedContractCode ?
                    {
                        ...data,
                        isUnblockChangeRequestAllowed: action.payload.unblockRequestData && action.payload.unblockRequestData.isChangeRequestAllowed,
                        unblockChangeRequest: {
                            ...data.unblockChangeRequest,
                            changeRequestNumber: action.payload.unblockRequestData.changeRequestNumber,
                            changeRequestStatus: action.payload.unblockRequestData.changeRequestStatus
                        }
                    } : data)
            }
        case UNBLOCK_REQUEST_NOT_ALLOWED:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                revenue: state.revenue.map((data, index) => index === action.payload.selectedContractCodeIndex ?
                    {
                        ...data,
                        isUnblockChangeRequestAllowed: false
                    } : data)
            }
        default:
            return state;
    }
}


function setSubmitSelectedSuccessData(contractData, changeRequestData, revenueDate, isWeekly) {
    const crData = changeRequestData.filter(d => (isWeekly ? (d.contractId === contractData.contId && d.revenueDate === contractData.revenueDate) : (d.contractId === contractData.contractId && d.revenueDate === revenueDate)));
    if (crData && crData.length === 1) {
        contractData = {
            ...contractData,
            revenueId: crData[0].revenueId,
            isSubmitted: crData[0].revenueId > 0,
            isSelectionAllowed: false,
            isChecked: false,
            isChangeRequestAllowed: crData[0].isChangeRequestAllowed,
            changeRequest: crData[0].isChangeRequestAllowed ? { ...crData[0].changeRequest } : null,
            revenueAmount: crData[0].changeRequest && crData[0].isChangeRequestAllowed ?
                { ...crData[0].changeRequest.revenueAmount }
                : { ...contractData.revenueAmount },
            soldTicket: crData[0].changeRequest && crData[0].isChangeRequestAllowed ?
                crData[0].changeRequest.soldTicket
                : contractData.soldTicket,
            isShopOpen: crData[0].changeRequest && crData[0].isChangeRequestAllowed ?
                crData[0].changeRequest.isShopOpen
                : contractData.isShopOpen,
            remarksId: crData[0].changeRequest && crData[0].isChangeRequestAllowed ?
                crData[0].changeRequest.remarksId
                : contractData.remarksId,
            remarksCode: crData[0].changeRequest && crData[0].isChangeRequestAllowed ?
                crData[0].changeRequest.remarksCode
                : contractData.remarksCode
        }
    }

    return contractData;
}

function InitialFormatRevenueData(initialData) {
    if (initialData && initialData.length > 0) {
        initialData = initialData.map((d,index) => {
            return {
                ...d,
                "index":index,
                "contId":d.contractId,
                "contractId":d.contractId + "#" + d.revenueDate                
            }
        });
    }
    return initialData;
}


